import { getPropsFromNode, nodeMatches } from '../utils'
import { h } from '../parser/utils'

export const NAME = 'paragraph'

export const COMPONENTS = {
}

export function matches(node) {
  return nodeMatches(node, 'p')
}

export async function transform(node, next, ctx) {
  const children = await next(node.childNodes, ctx)

  // Ignore completely empty paragraphs
  if (!node.textContent?.trim() && !children.length) {
    return
  }

  const props = getPropsFromNode(node)

  return h('p', props, ...children)
}

